/**
 * The raw spawned-process surface the pool hands a {@link WorkerDriver}, plus
 * the narrowing from a Node `ChildProcess` down to it. Keeping this generic
 * spawn-wrap piece separate is what lets the ffmpeg/browser pools reuse it
 * without depending on the pool coordinator.
 *
 * @module worker-pool/child-handle
 */

import type { ChildProcess } from 'node:child_process';
import type { Readable, Writable } from 'node:stream';

/** The raw spawned process surface a driver readies into a typed Handle. */
export interface ChildHandle {
  readonly pid: number | undefined;
  readonly stdin: Writable | null;
  readonly stdout: Readable | null;
  kill(signal?: NodeJS.Signals): void;
}

/** Narrow a Node ChildProcess to the {@link ChildHandle} the driver sees. */
export function wrapChild(child: ChildProcess): ChildHandle {
  return {
    get pid() {
      return child.pid;
    },
    stdin: child.stdin,
    stdout: child.stdout,
    kill: (signal) => void child.kill(signal),
  };
}
